module.exports = __webpack_public_path__ + "static/scale-model-of-c-tours-inc-in-springfield-massachusetts-8cc8880e9b6ff70b6922ffc1d7b1d22d.png";